import React from 'react';
import {
  PrivacyConsentBlock,
  PrivacyTitle,
  PrivacyText,
  PrivacyLink,
  ConsentCheckbox
} from '../SubjectForm.styles';
import { useTranslation } from 'react-i18next';
import ShieldIcon from '../icons/ShieldIcon';

interface PrivacyConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const PrivacyConsent: React.FC<PrivacyConsentProps> = ({ checked, onChange }) => {
  const { t } = useTranslation();

  return (
    <PrivacyConsentBlock>
      <ShieldIcon style={{ marginBottom: 8, width: '64px', height: '64px' }} />
      <PrivacyTitle>{t('howWeProtectYourPrivacy')}</PrivacyTitle>
      <PrivacyText>
        {t('privacyDescription')}{' '}
        <PrivacyLink href="/privacy-policy" target="_blank">{t('privacyPolicy')}</PrivacyLink>.
      </PrivacyText>
      <ConsentCheckbox>
        <input
          type="checkbox"
          id="privacy-consent"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor="privacy-consent">
          {t('privacyConsentText')}
        </label>
      </ConsentCheckbox>
    </PrivacyConsentBlock>
  );
};

export default PrivacyConsent;